/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import parseHtmlContent from "helpers/parseHtmlContent";

import {colors} from "nxtconstants";

import {
  wrapper,
  title,
  button,
  infoline,
  loader
} from "../styledElements";

const propTypes = {
  authRes: PropTypes.object,
  handlePinSetup: PropTypes.func,
  handleReset: PropTypes.func,
  isVerifying: PropTypes.bool,
  newPin: PropTypes.string
};

const PinVerification = ({
  authRes,
  handlePinSetup,
  handleReset,
  isVerifying,
  newPin
}) => {
  return (
    <UserCredentialsWrapper>
      <Title>
        {
          authRes.nextStep === "TWOFA_INPUT" ? (
            "Enter 4 Digit MPIN"
          ) : (
            newPin.length >= 4 ? (
              "Confirm MPIN"
            ) : (
              "Setup 4 Digit MPIN"
            )
          )
        }
      </Title>
      <InfoLine>
        {
          authRes.nextStep === "TWOFA_INPUT" ? (
            "Enter your 4 Digit MPIN to login"
          ) : (
            parseHtmlContent("To make login easier and keep account safe, <br /> set an MPIN")
          )
        }
      </InfoLine>
      <OtpWrapper>
        {
          isVerifying && (
            <Loader />
          )
        }
        <OtpInput
          autoFocus
          maxLength="4"
          type="password"
          onKeyUp={(e) => handlePinSetup(e)}
        />
        <InputBars>
          <Bar />
          <Bar />
          <Bar />
          <Bar />
        </InputBars>
      </OtpWrapper>
      <SubmitCredentials>
        {
          authRes.nextStep === "TWOFA_INPUT" ? (
            "Sign In"
          ) : (
            newPin.length >= 4 ? (
              "Confirm MPIN"
            ) : (
              "Setup MPIN"
            )
          )
        }
      </SubmitCredentials>
      {
        authRes.nextStep === "TWOFA_INPUT" ? (
          <ForgotPin>
            Forgot MPIN?&nbsp;
            <ResetButton onClick={handleReset}>
              Reset
            </ResetButton>
          </ForgotPin>
        ) : ("")
      }

    </UserCredentialsWrapper>
  );
};

const UserCredentialsWrapper = styled(wrapper)``;

const Title = styled(title)``;

const InfoLine = styled(infoline)``;

const OtpWrapper = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
  width: 282px;
  margin: 0 auto;

  &::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 5rem;
    top: 0;
    right: -5rem;
    background-color: ${colors.white};
  }

  @media (max-width: 768px) {
    width: 200px;
  }
`;

const Loader = styled(loader)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background-color: rgba(255,255,255,0.9);
`;

const OtpInput = styled.input`
  display: block;
  width: 130%;
  letter-spacing: 67px;
  padding: 1.2rem 0;
  padding-left: 22px;
  font-size: 24px;
  border: 0;
  outline: 0;
  color: ${colors.black};
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 20px;
    letter-spacing: 47.5px;
    padding-left: 15px;
  }
`;

const InputBars = styled.div`
  display: block;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Bar = styled.div`
  height: 1px;
  flex: 1;
  background-color: ${colors.textGray};
`;

const SubmitCredentials = styled(button)`
  width: 100%;
  margin: 4.4rem 0 2.4rem;
`;

const ForgotPin = styled.p`
  font-size: 1.6rem;
  color: ${colors.textGray};
  text-align: center;
`;

const ResetButton = styled.button`
  color: ${colors.primary};
  background-color: transparent;
  border: 0;
  font-size: 1.6rem;
  cursor: pointer;
  text-align: center;
`;

PinVerification.propTypes = propTypes;

export default PinVerification;
